import { jsx as _jsx } from "react/jsx-runtime";
/** Flux-style underline tabs (default variant). */
export function Tabs({ items, value, onChange, className = "" }) {
    return (_jsx("div", { className: ["flex h-10 gap-4 border-b border-zinc-800/10", className].join(" "), role: "tablist", children: items.map((item) => {
            const active = item.id === value;
            return (_jsx("button", { type: "button", role: "tab", "aria-selected": active, disabled: item.disabled, onClick: () => onChange(item.id), className: [
                    "-mb-px border-b-2 px-1 pb-2 text-sm font-medium transition-colors",
                    active
                        ? "border-[var(--color-accent)] text-zinc-900"
                        : "border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-800",
                    item.disabled ? "cursor-not-allowed opacity-50" : "",
                ].join(" "), children: item.label }, item.id));
        }) }));
}
export function TabPanel({ id, activeId, children, className = "" }) {
    if (id !== activeId)
        return null;
    return (_jsx("div", { role: "tabpanel", className: className, children: children }));
}
